export default "__VITE_ASSET__9JPV9Y78__"